<template>
  <div
    class="recommended-product-benefit-container"
    :class="selectedIndex === index ? 'hover' : ''"
    @mouseover="handleMouseOver"
    @mouseleave="handleMouseLeave"
    @click="benefitSelected"
  >
    <p>
      {{ text }}
    </p>
  </div>
</template>

<script>
  export default {
    name: 'RecommendedBenefit',
    components: {},
    props: {
      text: {
        required: true,
        default: '',
        type: String,
      },
      index: {
        required: true,
        type: Number,
      },
      selectedIndex: {
        required: true,
        type: Number,
      },
    },
    watch: {},

    data() {
      return {
        imgSrc: null,
      };
    },
    computed: {},
    methods: {
      handleMouseOver() {
        this.$emit('handleMouseOver', this.index);
      },
      handleMouseLeave() {
        this.$emit('handleMouseLeave', this.index);
      },
      benefitSelected() {
        this.$emit('benefitSelected', this.index);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .recommended-product-benefit-container {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    min-width: 124px;
    padding-left: 20px;
    padding-right: 20px;
    height: 60px;
    background-color: #f2f2f2;
    p {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      white-space: nowrap;
    }
  }

  .recommended-product-benefit-container.hover {
    p {
      color: #ed0080;
    }
  }

  @media only screen and (min-width: 960px) and (max-width: 1263px) {
    .recommended-product-benefit-container {
      padding-left: 20px;
      padding-right: 20px;
      width: auto !important;
      min-width: 0;
    }
  }
</style>
